import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { ValidationClassDto } from "./Entity";

const resolverValidator = classValidatorResolver(ValidationClassDto,{
    dismissDefaultMessages:true
});

export { resolverValidator };
